<div class="topbar-one">
    <div class="container">
        <div class="topbar-one__inner">
            <!-- Article vedette ticker -->
    <div class="featured-strip">
      <div class="featured-label">
        <div class="dot-live"></div> 
      </div>
      <div class="featured-ticker">
        <div class="ticker-items">
          <div class="ticker-item"><span class="tag">Communiqués</span> Suspension des licences de 35 prestataires de services publicitaires</div>
          <div class="ticker-item"><span class="tag">Succès</span> انعقاد مجلس سلطة تنظيم الإشهار في دورة عادية</div>
          <div class="ticker-item"><span class="tag">Evenements</span> Le Président de l'Autorité visite  l'Association caritative d'Ithar</div>
          <div class="ticker-item"><span class="tag">Communiqués</span> Le Président de l’Autorité exhorte le personnel de l’institution à la nécessité de rationaliser les ressources publiques</div>
          <div class="ticker-item"><span class="tag">Actualités</span> Le Président de l’Autorité rencontre les responsables de communication des banques</div>
          <!-- Duplicate for seamless loop --> 
         <div class="ticker-item"><span class="tag">Communiqués</span> Suspension des licences de 35 prestataires de services publicitaires</div>
          <div class="ticker-item"><span class="tag">Succès</span> انعقاد مجلس سلطة تنظيم الإشهار في دورة عادية</div>
          <div class="ticker-item"><span class="tag">Evenements</span> Le Président de l'Autorité visite  l'Association caritative d'Ithar</div>
          <div class="ticker-item"><span class="tag">Communiqués</span> Le Président de l’Autorité exhorte le personnel de l’institution à la nécessité de rationaliser les ressources publiques</div>
          <div class="ticker-item"><span class="tag">Actualités</span> Le Président de l’Autorité rencontre les responsables de communication des banques</div>
          
        </div>
      </div>
    </div>
            <p class="topbar-one__info"> 

            </p><!-- /.topbar-one__text -->
            <div class="topbar-one__social">
                <p class="topbar-one__social__text"> </p>
                <a href="{{ setting?.facebook }}" style="--accent-color: #3b5998;">
                    <i class="fab fa-facebook-f" aria-hidden="true"></i>
                    <span class="sr-only">Facebook</span>
                </a>
                <a href="{{ setting?.linkedin }}" style="--accent-color: #0A66C2;">
                    <i class="fa-brands fa-square-linkedin"></i>
                    <span class="sr-only">LinkedIn</span>
                </a>
                <a href="{{ setting?.twitter }}" style="--accent-color: #000000;">
                   <i class="fa-brands fa-square-x-twitter"></i>
                    <span class="sr-only">Twitter</span>
                </a>
                 
            </div><!-- /.topbar-one__social -->
        </div><!-- /.topbar-one__inner -->
    </div><!-- /.container -->
    <div class="topbar-one__bottom">
        <div class="container">
            <div class="topbar-one__bottom__inner">
                <div class="topbar-one__bottom__logo">
                    <a href="/">
                        <img src="/logo-header.png" alt="ARP" style="height: 50px;">
                    </a>
                </div><!-- /.main-header__logo -->
                <div class="topbar-one__bottom__right">

                    <div class="topbar-one__bottom__info" >
                            
                       <a href="https://center.arp.gov.mr" class="careox-btn"><span>{{'licence' | translate }}</span></a>
                           
                    </div><!-- /.topbar-one__info -->
                   
                    <div class="topbar-one__bottom__info" >
                            
                       <a [routerLink]="['/paiement']" class="careox-btn"><span>  {{'paiement' | translate}}</span></a>
                           
                    </div><!-- /.topbar-one__info -->
                    <div class="topbar-one__bottom__info" style="--accent-color: #8139e7;">
                          <a href="/annuaire" class="careox-btn"><span><i class="icon-magnifying-glass"></i> {{'agrees' | translate}}</span></a>
                    </div><!-- /.topbar-one__info -->
                </div>
            </div>
        </div>
       
    </div><!-- /.middle-one -->
</div><!-- /.topbar-one -->